// Your guided conversations (28 Oct 2026): /guided/:customer, every
// invitation the signed-in person has at this customer, with its state.
// An invitation arrives in the bell; this is where they are all listed.

import React from 'react'
import { Alert, Box, Button, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import useRouter from '../hooks/useRouter'
import useAccount from '../hooks/useAccount'
import { useGuidedMine } from '../hooks/useGuidedResponse'
import PageHeader from '../components/system/PageHeader'
import { RESPONSE_STATUS_LABELS, formatGuideTime } from '../utils/guided'

export default function GuidedListPage() {
  const router = useRouter()
  const account = useAccount()
  const customer = (router.params.customer as string | undefined) || account.customer?.name || ''
  const mine = useGuidedMine(customer)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <PageHeader title="Your guided conversations" subtitle="Conversations a Manager invited you to. Open one to start, or to carry on where you stopped." />
      <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        {mine.isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>
        ) : mine.error ? (
          <Alert severity="error">{mine.error}</Alert>
        ) : mine.items.length === 0 ? (
          <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
            You have no guided conversations. When a Manager invites you to one, the invitation arrives in the bell.
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small" aria-label="Your guided conversations">
              <TableHead>
                <TableRow>
                  <TableCell>Conversation</TableCell>
                  <TableCell>State</TableCell>
                  <TableCell>Invited</TableCell>
                  <TableCell>Last active</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {mine.items.map(({ response, guide_title }) => (
                  <TableRow key={response.id} hover>
                    <TableCell>{guide_title}</TableCell>
                    <TableCell>{RESPONSE_STATUS_LABELS[response.status]}</TableCell>
                    <TableCell>{formatGuideTime(response.invited_at)}</TableCell>
                    <TableCell>{formatGuideTime(response.last_active_at) || '—'}</TableCell>
                    <TableCell align="right">
                      <Button size="small" color="info" onClick={() => router.navigate('guided-response', { customer, responseId: response.id })}>
                        Open
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  )
}
